import { AppRouter } from "./approuter";

// Append the app router.
const app = new AppRouter();
window.document.body.append(app);

// Load the service worker.
window.addEventListener("load", () => {
  if (
    "serviceWorker" in navigator &&
    window.location.hostname !== "localhost"
  ) {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("SW registered: ", registration);
      })
      .catch((registrationError) => {
        console.log("SW registration failed: ", registrationError);
      });
  }
});
